// import { Trans } from '@lingui/react';
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { useParams, Redirect } from "react-router";
import { Button, Row, Col } from "reactstrap";
import { AuthApi } from "../api/AuthApi";
import FormComponent from "../components/FormComponent";
import ExternalLayout from "../components/layouts/ExternalLayout";
import { AuthContext } from "../context/AuthContext";

const ChangePassword = FormComponent({
  displayName: "ChangePassword",
  schema: {
    title: "Cambiar contraseña",
    type: "object",
    properties: {
      password: { title: "New Password", type: "string" },
      passwordConfirm: { title: "Confirm Password", type: "string" },
    },
    required: ["password", "passwordConfirm"],
  },
  uiSchema: {
    password: { "ui:widget": "password" },
    passwordConfirm: { "ui:widget": "password" },
  },
  parseProps: () => ({
    params: useParams(),
    auth: useContext(AuthContext),
  }),
  async onSubmit(
    { formData: { password, passwordConfirm } },
    { props: { auth } }
  ) {
    const user = await AuthApi.changePassword({ password, passwordConfirm });
    if (user) {
      auth.setChangePassword(user.data.changePassword);
    }
  },
  validate({ password, passwordConfirm }, errors) {
    if (password !== passwordConfirm) {
      errors.passwordConfirm.addError("Las contraseñas no son iguales");
    }
    return errors;
  },
  renderFormChildren: () => (
    <Row>
      <Col>
        <Button color="primary" type="submit">
          Confirmar contraseña
        </Button>
      </Col>
    </Row>
  ),
  renderFormSubmitted: () => {
    return <Redirect path="/" />;
  },
});

export default function() {
  return (
    <ExternalLayout style={{ paddingBotton: 20 }}>
      <div style={{ paddingTop: 50 }}>
        <ChangePassword />
      </div>
    </ExternalLayout>
  );
}
